import React from 'react';
import { motion } from 'framer-motion';
import { publicLayout, publicMotion } from '../../styles/publicDesignSystem';

const PublicCtaBand = ({
  sectionVariant = 'accent',
  badge,
  badgeIcon: BadgeIcon,
  title,
  titleHighlight,
  subtitle,
  subtitleHighlight,
  primaryAction,
  secondaryAction,
  footerItems = [],
  className = ''
}) => {
  const sectionVariantClasses = {
    accent: publicLayout.sectionAccent,
    surface: publicLayout.sectionSurface,
    muted: publicLayout.sectionMuted
  };
  const sectionClass = sectionVariantClasses[sectionVariant] || publicLayout.sectionAccent;

  return (
    <section className={`${sectionClass} public-cta-band relative overflow-hidden ${className}`}>
      <div className="public-cta-band-bg absolute inset-0 opacity-10" aria-hidden="true">
        <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-white" />
        <div className="absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-yellow-300" />
      </div>

      <div className={`${publicLayout.container} relative`}>
        <motion.div {...publicMotion.sectionReveal} className="public-cta-band-content text-center">
          {badge ? (
            <div className="public-cta-band-badge inline-flex items-center rounded-full bg-white/15 px-4 py-2 text-sm font-medium text-white mb-8 border border-white/20">
              {BadgeIcon ? <BadgeIcon className="h-4 w-4 mr-2" /> : null}
              {badge}
            </div>
          ) : null}

          {title ? (
            <h2 className="public-cta-band-title text-4xl lg:text-5xl font-bold leading-tight">
              {title}
              {titleHighlight ? <span className="block text-yellow-300">{titleHighlight}</span> : null}
            </h2>
          ) : null}
          {subtitle ? (
            <p className="public-cta-band-subtitle text-xl text-primary-100 max-w-4xl mx-auto mt-6">
              {subtitle}
              {subtitleHighlight ? <span className="block mt-2 text-yellow-300 font-semibold">{subtitleHighlight}</span> : null}
            </p>
          ) : null}

          <div className="public-cta-band-actions mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            {primaryAction}
            {secondaryAction}
          </div>

          {footerItems.length ? (
            <div className="public-cta-band-footer mt-10 grid gap-4 md:grid-cols-3 max-w-4xl mx-auto text-primary-100">
              {footerItems.map((item) => (
                <div key={item.key || item.text} className="flex items-center justify-center gap-2">
                  {item.icon ? <item.icon className="h-4 w-4 text-green-300" /> : null}
                  <span className="text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          ) : null}
        </motion.div>
      </div>
    </section>
  );
};

export default PublicCtaBand;
